// Import components
import _ from 'lodash'
import {
  url as _url
} from '@/libs/join'

import VisitShort from '@/components/visit/VisitShort.vue'
import VisitControlBase from "@/components/visit/VisitControlBase";
import VisitControlMgBase from "@/components/visit/VisitControlMgBase";
import ApprSubm from '@/views/ApprSubm.vue'

export default {
  props: {
    visitNo: {
      type: String,
      required: false
    },
    copyVisitNo: {
      type: String,
      required: false
    }
  },
  components: {
    VisitShort,
    VisitControlBase,
    VisitControlMgBase,
    ApprSubm
  },
  data() {
    return {
      status: {
        new: true,
        loaded: false,
        readonly: false,
        change: false,
        memento: []
      }
    }
  },
  computed: {
    /**
     * 신규 전표 여부
     */
    isNew() {
      return this.visitNo === undefined
    },
    isReadOnly() {
      return this.status.readonly
    },
    isViewAppr() {
      return this.status.readonly && this.data.visitTypeCd !== 'BOOK'
    },
    /**
     * 결재상신 가능 여부
     */
    isSubmitable() {
      return !this.status.readonly && this.$store.state.loginInfo.loginId === this.data.visitEmp
    },
    /**
     * 신규작성 가능 여부
     */
    isCreateable() {
      return this.isNew || !this.status.readonly
    },
    /**
     * 삭제 가능 여부
     */
    isDeleteable() {
      return !this.isNew && !this.status.readonly
    },
    /**
     * 저장 가능 여부
     */
    isSaveable() {
      return this.isNew || !this.status.readonly && this.$store.state.loginInfo.loginId === this.data.visitEmp
    },
    isCancelable() {
      return this.$store.state.loginInfo.loginId === this.data.visitEmp && this.data.visitStatCd !== '40' && this.data.visitStatCd !== '60' && this.data.visitStatCd !== '70' && this.data.visitStatCd !== '80'
    },
    isDoneable() {
      return this.$store.state.loginInfo.loginId === this.data.visitEmp && this.data.visitStatCd === '50'
    }
  },
  watch: {
    'visitNo': {
      immediate: true,
      deep: true,
      handler(value) {
        this.$http.post(`/api/visit/checkVisitHistory`, {visitNo: value}
        ).then((response) => {
          this.cancelYN = response.data === 0 ? true : false
        })
      }
    },
  },
  methods: {
    /**
     * ==========================================
     * 이벤트 처리 함수
     * ==========================================
     */
    /**
     * 출력 버튼 클릭 이벤트
     */
    buttonEventPrint() {
      // TODO::전표출력
    },
    /**
     * 결재보기 버튼 클릭 이벤트
     */
    buttonEventViewSubmit() {
      if(!this.data.elecApprId){
          if(this.data.visitStatCd == '50' || this.data.visitStatCd == '60'){
              this.$swal({type: 'info', text: '방명록 작성건으로 결재내역이 없습니다.'});
              return
          } else {
              this.$swal({type: 'info', text: '상신 내역이 없습니다.'});
              return
          }
      }

      this.$modal.open({
        component: ApprSubm,
        props: {
          docType: 'SHORT',
          value: this.data,
          docMngNo: this.data.elecApprId
        },
        parent: this,
        width: 1200
      })
    },
    /**
     * 결재 상신 버튼 클릭 이벤트
     */
    buttonEventSubmit() {
      if (this.data.visitPlaceCd == '' || this.data.visitPlaceCd == null){
          this.$swal({type: 'info', text: '출입장소를 선택하세요.'});
        return
      }


      if (this.isNew) {
        this.buttonEventSave(__proceed)
      } else {
        __proceed.apply(this, [this.visitNo])
      }
      const param = JSON.parse(JSON.stringify(this.data));

      this.$http.post(`/api/visit/save`, {visitHeader : param});

      function __proceed(visitNo) {
        const vm = this
        this.$modal.open({
          component: ApprSubm,
          props: {
            docType: 'SHORT',
            value: this.data
          },
          parent: this,
          width: 1200,
          events: {
            close() {
              if (vm.$route.elecApprId !== undefined) {
                location.reload()
              } else {
                vm.$router.push({
                  name: vm.name,
                  params: {
                    visitNo
                  }
                })
              }
            }
          }
        })
      }
    },
    /**
     * 신규 작성 버튼 클릭 이벤트
     */
    buttonEventCreate() {
      if (this.status.memento.length > 1) {
        this.$swal({
          type: 'warning',
          text: '변경된 데이터가 있습니다. 계속 하시겠습니까?',
          showCancelButton: true
        }).then(val => {
          val.value ? this.create() : 0
        })
      } else {
        this.create()
      }
    },
    /**
     * 삭제 버튼 클릭 이벤트
     */
    buttonEventDelete() {
      this.$swal({
        type: 'question',
        text: '삭제하시겠습니까?',
        showCancelButton: true
      }).then(val => {
        if (val.value) {
          this.$http.delete(_url('/api/slip', this.data.visitNo))
            .then(response => {
              this.$swal({
                type: 'success',
                text: '삭제되었습니다.'
              }).then(() => {
                this.$router.push({
                  name: 'slipLst'
                })
              })
              return response
            })
            .catch(response => {
              return response
            })
        }
      })
    },

    /**
     * 취소 버튼 클릭 이벤트
     */
    buttonEventCancel(callback) {
      this.$swal({
        type: 'info',
        title: '방문 취소',
        text: `해당 방문 건을 취소 처리합니다. 계속 하시겠습니까?`,
        input: "text",
        closeOnClickOutside: false,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          const param = JSON.parse(JSON.stringify(this.data));
          param.cancelRsn = result.value
          param.visitStatCd = '80'

          this.$http.post(`/api/visit/updateStat`, param
          ).then((response) => {
            this.$swal({ type: 'success', text: '완료되었습니다.'
            }).then((result) => {
              this.data.cancelRsn  = param.cancelRsn
              this.data.visitStatNm  = '방문취소'
              this.data.visitStatCd = '80'
              this.status.readonly = true
            });
          }).catch((e) => {
            console.error(e);
          });
        } else if(result.value !== undefined){
          this.$swal({
            type: 'warning',
            confirmButtonText: '확인',
            text: '취소사유를 입력해주세요.'
          }).then((result) => {
            this.buttonEventCancel()
          });
        }
      });
    },
    /**
     * 방문완료 버튼 클릭 이벤트
     */
    buttonEventDone(callback) {
      this.$swal({
        type: 'info',
        title: '방문 완료',
        text: `해당 방문 건을 완료 처리합니다. 계속 하시겠습니까?`,
        closeOnClickOutside: false,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          const param = JSON.parse(JSON.stringify(this.data));
          param.visitStatCd = '60'

          this.$http.post(`/api/visit/updateStat`, param
          ).then((response) => {
            this.$swal({ type: 'success', text: '완료되었습니다.'
            }).then((result) => {
              this.data.visitStatNm  = '방문완료'
              this.data.visitStatCd = '60'
            });
          }).catch((e) => {
            console.error(e);
          });
        }
      });
    },
    /**
     * 저장 버튼 클릭 이벤트
     */
    buttonEventSave(callback) {
      this.$swal({
        type: 'info',
        text: `변경내역을 저장합니다. 계속 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          const param = JSON.parse(JSON.stringify(this.data));

          this.$http.post(`/api/visit/save`, {visitHeader : param}
          ).then((response) => {
            this.$swal({ type: 'info', text: '완료되었습니다.'
            }).then((result) => {
            });
          }).catch((e) => {
            console.error(e);
          });
        }
      });

      /*
        // TODO::데이터 저장
        var slipHeader = _.clone(this.data)
        // 작성일자를 지운다
        delete slipHeader.wrtDtm
        delete slipHeader.regDtm
        delete slipHeader.fnlApprDtm
        delete slipHeader.fnlAprverId
        delete slipHeader.elecApprId
        delete slipHeader.elecApprDtm
        for (var member in slipHeader) {
          if (slipHeader[member] != null) {
            if (member.match(/.*Amt$/g)) {
              slipHeader[member] = this.$numeral(slipHeader[member]).value()
            } else if (member.match(/.*(Dt)$/g)) {
              slipHeader[member] = this.$moment(slipHeader[member]).format('YYYYMMDD')
            }
          }
        }

        slipHeader.slipDetails = slipHeader.slipDetails.map(x => {
          delete x.regDtm
          delete x.chgDtm
          for (var member in x) {
            if (x[member] != null) {
              if (member.match(/^.*Amt$/g)) {
                x[member] = this.$numeral(x[member]).value()
              } else if (member.match(/^.*Dt$/g)) {
                x[member] = this.$moment(x[member]).format('YYYYMMDD')
              }
            }
          }
          return x
        })

        // if (slipHeader.slipTypeCd === 'E6' || slipHeader.slipTypeCd === 'E7') {
          if (slipHeader.slipTypeCd === 'E6' ) {
          slipHeader.supAmt = slipHeader.totAmt
        }

        // 대표계정코드
        slipHeader.stnAcctCd = slipHeader.slipDetails.filter(x => [x.dcCd, x.lnTypeCd].join('_') === 'D_ITEM')[0].acctCd

        this.$http.post('/api/slip', slipHeader)
          .then(response => {
            if (callback !== undefined && typeof callback === 'function') {
              callback.apply(this, [response.data.visitNo])
            } else {
              this.$swal({
                type: 'success',
                text: '저장되었습니다.'
              }).then(() => {
                this.reroute(response.data.visitNo)
              })
            }
            return response
          })
          .catch(response => {
            return response
          })

       */
    },
    /**
     * 일반 이벤트 함수
     */
    reroute(visitNo) {
      //    if (this.eaSlipNo === undefined || this.eaSlipNo !== eaSlipNo) {
      this.$router.push({
        name: this.name + 'Edit',
        params: {
          visitNo
        }
      })
      /*      } else {
              window.location.reload()
            }*/
    },
    create() {
      if (this.$route.params.visitNo) {
        this.$router.push({
          name: this.name + 'New'
        })
      } else {
        window.location.reload()
      }
    },
    setGridStatus(isLoaded, isNew, isReadonly) {
      this.status.loaded = isLoaded
      this.status.new = isNew
      this.status.readonly = isReadonly
      this.gridType = isReadonly ? 'GridRO' : 'GridED'
      this.$forceUpdate()
    },
    uploadFile() {
      this.$modal.open({
        component: EvidAtchPop,
        parent: this,
        width: 1200
      })
    }
  },
  created() {
    this.status.memento = []
  }
}
